import React, { useEffect, useState, type Dispatch } from 'react';
import globalWindow from 'global';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isLineBreakNode, $isRangeSelection, CLICK_COMMAND, COMMAND_PRIORITY_CRITICAL, COMMAND_PRIORITY_LOW, SELECTION_CHANGE_COMMAND } from 'lexical';
import { getSelectedNode } from '../../utils/utils';
import { $findMatchingParent, mergeRegister } from '@lexical/utils';
import { $isAutoLinkNode, $isLinkNode } from '@lexical/link';
import LinkEditor from './link-editor';
import { createPortal } from 'react-dom';
const LinkEditorPlugin = ({
  anchorElem = document.body,
  isLinkEditMode,
  setIsLinkEditMode
}: {
  anchorElem?: HTMLElement;
  isLinkEditMode: boolean;
  setIsLinkEditMode: Dispatch<boolean>;
}) => {
  const [editor] = useLexicalComposerContext();
  const [isLink, setIsLink] = useState<boolean>(false);
  useEffect(() => {
    const updateToolbar = () => {
      const selection = $getSelection();
      if (!$isRangeSelection(selection)) {
        return;
      }
      const focusNode = getSelectedNode(selection);
      const focusLinkNode = $findMatchingParent(focusNode, $isLinkNode);
      const focusAutoLinkNode = $findMatchingParent(focusNode, $isAutoLinkNode);
      if (!(focusLinkNode || focusAutoLinkNode)) {
        setIsLink(false);
        return;
      }
      const badNode = selection.getNodes().filter(node => !$isLineBreakNode(node)).find(node => {
        const linkNode = $findMatchingParent(node, $isLinkNode);
        const autoLinkNode = $findMatchingParent(node, $isAutoLinkNode);
        return focusLinkNode && !focusLinkNode.is(linkNode) || linkNode && !linkNode.is(focusLinkNode) || focusAutoLinkNode && !focusAutoLinkNode.is(autoLinkNode) || autoLinkNode && !autoLinkNode.is(focusAutoLinkNode);
      });
      if (!badNode) {
        setIsLink(true);
      } else {
        setIsLink(false);
      }
    };
    return mergeRegister(editor.registerUpdateListener(({
      editorState
    }) => {
      editorState.read(() => {
        updateToolbar();
      });
    }), editor.registerCommand(SELECTION_CHANGE_COMMAND, () => {
      updateToolbar();
      return false;
    }, COMMAND_PRIORITY_CRITICAL), editor.registerCommand(CLICK_COMMAND, payload => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        const node = getSelectedNode(selection);
        const linkNode = $findMatchingParent(node, $isLinkNode);
        if ($isLinkNode(linkNode) && (payload.metaKey || payload.ctrlKey)) {
          globalWindow.open(linkNode.getURL(), '_blank', 'noopener');
          return true;
        }
      }
      return false;
    }, COMMAND_PRIORITY_LOW));
  }, [editor]);
  return <>
      {createPortal(<LinkEditor editor={editor} anchorElem={anchorElem} isLink={isLink} setIsLink={setIsLink} isLinkEditMode={isLinkEditMode} setIsLinkEditMode={setIsLinkEditMode} />, anchorElem)}
    </>;
};
export default LinkEditorPlugin;